var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checklist"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38,11.65a1,1,0,0,0,.76.35h0a1,1,0,0,0,.77-.42l2.85-4a1,1,0,0,0-1.62-1.16l-2.12,3L8.76,9a1,1,0,1,0-1.52,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38,17.65a1,1,0,0,0,.76.35h0a1,1,0,0,0,.77-.42l2.85-4a1,1,0,0,0-1.62-1.16l-2.12,3L8.76,15a1,1,0,1,0-1.52,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.19,19.62a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,10.19,19.62Zm0,4.38a1.19,1.19,0,1,1,0-2.38,1.19,1.19,0,1,1,0,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,8.08H16a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,15H16a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,21.92H16a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.15,2H5.85A3.86,3.86,0,0,0,2,5.85v20.3A3.86,3.86,0,0,0,5.85,30h20.3A3.86,3.86,0,0,0,30,26.15V5.85A3.86,3.86,0,0,0,26.15,2ZM28,26.15A1.85,1.85,0,0,1,26.15,28H5.85A1.85,1.85,0,0,1,4,26.15V5.85A1.85,1.85,0,0,1,5.85,4h20.3A1.85,1.85,0,0,1,28,5.85Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.e7d970b80a3ceab25cfb855c2558b43b.svg";
export { ForwardRef as ReactComponent };